import { styled } from '@mui/material/styles';

const IconWrap = styled('span')({
  display: 'inline-flex',
});

export function InstallIcon() {
  return (
    <IconWrap>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path
          d="M7.5 4.5H16.5C17.3284 4.5 18 5.17157 18 6V18C18 18.8284 17.3284 19.5 16.5 19.5H7.5C6.67157 19.5 6 18.8284 6 18V6C6 5.17157 6.67157 4.5 7.5 4.5Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 8V14"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M9.5 11.5L12 14L14.5 11.5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 2.75H15"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M12 17.25H12.01"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
        />
      </svg>
    </IconWrap>
  );
}
